import { createFileRoute } from "@tanstack/react-router";
import { BlogIndexPage, blogIndexHeadDa } from "@/pages/BlogIndexPage";

export const Route = createFileRoute("/blog/")({
  head: blogIndexHeadDa,
  component: BlogIndexPage,
});
